const SVGComponent = (props) => (
  <svg
    width={32}
    height={20}
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V14C32 17.3137 29.3137 20 26 20H6C2.68629 20 0 17.3137 0 14V6Z"
      fill="#27272A"
    />
    <path
      d="M18.9762 4.41284H13.0303V14.7872H18.9762V4.41284Z"
      fill="#FF5F00"
    />
    <path
      d="M13.408 9.601C13.4067 8.60185 13.6396 7.61552 14.0891 6.71668C14.5385 5.81783 15.1927 5.03004 16.0021 4.41295C14.9994 3.64704 13.7948 3.17054 12.5263 3.03793C11.2577 2.90533 9.97629 3.12197 8.82857 3.66309C7.68084 4.2042 6.71314 5.04795 6.03609 6.09786C5.35905 7.14777 5 8.36145 5 9.60014C5 10.8388 5.35905 12.0525 6.03609 13.1024C6.71314 14.1523 7.68084 14.9961 8.82857 15.5372C9.97629 16.0783 11.2577 16.2949 12.5263 16.1623C13.7948 16.0297 14.9994 15.5532 16.0021 14.7873C15.193 14.1704 14.5389 13.3829 14.0895 12.4844C13.64 11.5859 13.407 10.5999 13.408 9.601Z"
      fill="#EB001B"
    />
    <path
      d="M27.0002 9.60187C26.9992 10.8395 26.6398 12.052 25.9629 13.1008C25.2861 14.1496 24.3191 14.9926 23.1724 15.5334C22.0257 16.0742 20.7455 16.2911 19.4779 16.1593C18.2103 16.0276 17.0064 15.5524 16.0037 14.7882C16.8123 14.1706 17.466 13.3828 17.9154 12.4843C18.3649 11.5857 18.5985 10.5999 18.5985 9.60101C18.5985 8.60213 18.3649 7.61627 17.9154 6.71775C17.466 5.81922 16.8123 5.03146 16.0037 4.41382C17.0064 3.64957 18.2103 3.17444 19.4779 3.04267C20.7455 2.91091 22.0257 3.12781 23.1724 3.66863C24.3191 4.20945 25.2861 5.05239 25.9629 6.10121C26.6398 7.15003 26.9992 8.36248 27.0002 9.60014V9.60187Z"
      fill="#F79E1B"
    />
  </svg>
);
export default SVGComponent;